import * as types from "./mutation_types";

let setCoCodeMapDetail = ({ commit }, data) => {
  commit(types.COMMON_CODE_MAP_DETAIL, data, { root: false });
};

let setTargetJuso = ({ commit }, data) => {
  commit(types.TARGET_JUSO, data, { root: false });
};

let setAuthToken = ({ commit }, data) => {
  commit(types.AUTH_TOKEN, data, { root: false });
};

let setUserInfo = ({ commit }, data) => {
  commit(types.USER_INFO, data, { root: false });
};

let setOwnerJuso = ({ commit }, data) => {
  commit(types.OWNER_JUSO, data, { root: false });
};

// 공인중개사
let setAgtPropertyInquiryStep1 = ({ commit }, data) => {
  commit(types.AGT_PROPERTY_INQUIRY_STEP1, data, { root: false });
};
let setAgtPropertyInquiryStep2 = ({ commit }, data) => {
  commit(types.AGT_PROPERTY_INQUIRY_STEP2, data, { root: false });
};
let setAgtPropertyInquiryStep3 = ({ commit }, data) => {
  commit(types.AGT_PROPERTY_INQUIRY_STEP3, data, { root: false });
};

// 임대인
let setPropertyInquiryStep1 = ({ commit }, data) => {
  commit(types.PROPERTY_INQUIRY_STEP1, data, { root: false });
};
let setPropertyInquiryStep2 = ({ commit }, data) => {
  commit(types.PROPERTY_INQUIRY_STEP2, data, { root: false });
};
let setPropertyInquiryStep3 = ({ commit }, data) => {
  commit(types.PROPERTY_INQUIRY_STEP3, data, { root: false });
};
let setPropertyInquiryStep4 = ({ commit }, data) => {
  commit(types.PROPERTY_INQUIRY_STEP4, data, { root: false });
};

//for Clear
let setPropertyClear = ({ commit }) => {
  commit(types.PROPERTY_CLEAR, { root: false });
};

export default {
  saveCoCodeMap(store, data) {
    store.commit(types.COMMON_CODE_MAP, data, { root: false });
  },
  saveCoCodeMapDetail(store, data) {
    store.commit(types.COMMON_CODE_MAP_DETAIL, data, { root: false });
  },
  saveTargetJuso(store, data) {
    store.commit(types.TARGET_JUSO, data, { root: false });
  },
  setAuthToken(store, data) {
    store.commit(types.AUTH_TOKEN, data, { root: false });
  },
  setUserInfo(store, data) {
    setUserInfo(store, data);
  },
  saveOwnerJuso(store, data) {
    setOwnerJuso(store, data);
  },
  // 공인중개사
  saveAgtPropertyInquiryStep1(store, data) {
    setAgtPropertyInquiryStep1(store, data);
  },
  saveAgtPropertyInquiryStep2(store, data) {
    setAgtPropertyInquiryStep2(store, data);
  },
  saveAgtPropertyInquiryStep3(store, data) {
    setAgtPropertyInquiryStep3(store, data);
  },

  // 임대인
  savePropertyInquiryStep1(store, data) {
    setPropertyInquiryStep1(store, data);
  },
  savePropertyInquiryStep2(store, data) {
    setPropertyInquiryStep2(store, data);
  },
  savePropertyInquiryStep3(store, data) {
    setPropertyInquiryStep3(store, data);
  },
  savePropertyInquiryStep4(store, data) {
    setPropertyInquiryStep4(store, data);
  },

  //ppt정보 클리어
  clearPropertyInquiry(store) {
    console.log("clear");
    console.log(store);
    setPropertyClear(store);
  }
};
